import { init } from './MallCPA15';
init();
